import {
    LIST_USERS_SUCCESS,
    OPEN_UPDATE_DIALOG,
    OPEN_CREATE_DIALOG,
    CLOSE_DIALOGS,
    CREATE_USER,
    CREATE_USER_SUCCESS,
    CREATE_USER_FAILURE,
    UPDATE_USER_SUCCESS,
    UPDATE_USER_FAILURE,
    DELETE_USER_FAILURE,
    DELETE_USER_SUCCESS,
    DELETE_USER,
    UPDATE_USER,
    RESET_USER_PASSWORD,
    RESET_USER_PASSWORD_SUCCESS,
    RESET_USER_PASSWORD_FAILURE,
} from "./UsersActionTypes";

export const initialUsersState = () => ({
    userList: null,
    username: null,
    role: null,
    userForm: {
        emailUsername: null,
        emailUsernameRepetition: null,
        email: null,
        name: null,
        hsaId: null,
        organizationId: null,
        streetAddress: null,
        zipCode: null,
        city: null,
        contactName: null,
        contactPhoneNumber: null,
        clinicInfo: null,
    },
    createDialogOpen: false,
    updateDialogOpen: false,
    deleteDialogOpen: false,
    resetPasswordSuccess: false,
    saveUserError: null,
    isLoading: false,
});

const users = (state = initialUsersState(), action) => {
    switch (action.type) {
        case LIST_USERS_SUCCESS:
            return {
                ...state,
                createDialogOpen: false,
                updateDialogOpen: false,
                deleteDialogOpen: false,
                userList: action.users,
                username: null,
                role: null,
                userForm: initialUsersState().userForm,
            };
        case OPEN_CREATE_DIALOG:
            return {
                ...state,
                createDialogOpen: true,
                updateDialogOpen: false,
                deleteDialogOpen: false,
                username: null,
                role: null,
                userForm: initialUsersState().userForm,
            };
        case OPEN_UPDATE_DIALOG:
            return {
                ...state,
                createDialogOpen: false,
                updateDialogOpen: true,
                deleteDialogOpen: false,
                username: action.username,
                role: action.role,
                organizationId: action.organizationId,
                userForm: action.userForm,
            };
        case CLOSE_DIALOGS:
            return {
                ...state,
                createDialogOpen: false,
                updateDialogOpen: false,
                deleteDialogOpen: false,
                username: null,
                role: null,
                organizationId: null,
                resetPasswordSuccess: false,
                saveUserError: null,
            };
        case CREATE_USER:
            return {
                ...state,
                isLoading: true,
                saveUserError: null,
            };
        case CREATE_USER_SUCCESS:
            return {
                ...state,
                isLoading: false,
                createDialogOpen: false,
                saveUserError: null,
            };
        case CREATE_USER_FAILURE:
            return {
                ...state,
                isLoading: false,
                createDialogOpen: true,
                saveUserError: action.message || "Fel vid försök att skapa användare",
            };
        case UPDATE_USER:
            return {
                ...state,
                isLoading: true,
                saveUserError: null,
            };
        case UPDATE_USER_SUCCESS:
            return {
                ...state,
                isLoading: false,
                updateDialogOpen: false,
                saveUserError: null,
            };
        case UPDATE_USER_FAILURE:
            return {
                ...state,
                isLoading: false,
                updateDialogOpen: true,
                saveUserError:
                    action.message || "Fel vid försök att uppdatera användare",
            };
        case DELETE_USER:
            return {
                ...state,
                isLoading: true,
                saveUserError: null,
            };
        case DELETE_USER_SUCCESS:
            return {
                ...state,
                isLoading: false,
                updateDialogOpen: false,
                saveUserError: null,
            };
        case DELETE_USER_FAILURE:
            return {
                ...state,
                isLoading: false,
                saveUserError: action.message || "Fel vid försök att ta bort användare",
            };
        case RESET_USER_PASSWORD:
            return {
                ...state,
                isLoading: true,
                saveUserError: null,
            };
        case RESET_USER_PASSWORD_SUCCESS:
            return {
                ...state,
                isLoading: false,
                resetPasswordSuccess: true,
                saveUserError: null,
            };
        case RESET_USER_PASSWORD_FAILURE:
            return {
                ...state,
                isLoading: false,
                saveUserError: action.message || "Fel vid försök att återställa lösenord",
            };
        default:
            return state;
    }
};
export default users;
